import { render, staticRenderFns } from "./Achievement.vue?vue&type=template&id=1ca67b3c&scoped=true"
import script from "./Achievement.vue?vue&type=script&lang=js"
export * from "./Achievement.vue?vue&type=script&lang=js"
import style0 from "./Achievement.vue?vue&type=style&index=0&id=1ca67b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca67b3c",
  null
  
)

export default component.exports